import { forwardRef } from 'react';
import styled from 'styled-components';

import { Button } from 'app/theme/Button';
import { UploadIcon } from 'app/theme/Icons/UploadIcon';
import { common } from 'app/translations/dictionary';

interface FileUploaderButtonProps {
  filesCount?: number;
  disabled?: boolean;
}

const StyledUploadIcon = styled(UploadIcon)`
  margin-right: 1rem;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: stretch;
  width: 100%;
`;

const FullwidthButton = styled(Button)`
  width: 100%;
`;

export const FileUploaderButton = forwardRef<HTMLDivElement, FileUploaderButtonProps>(
  ({ filesCount = 0, disabled = false, ...props }, ref): JSX.Element => (
    <ButtonContainer ref={ref} {...props}>
      <FullwidthButton disabled={disabled} type="button" secondary size="huge">
        <StyledUploadIcon />
        {common.uploadFiles} {Boolean(filesCount) && `(${filesCount})`}
      </FullwidthButton>
    </ButtonContainer>
  )
);
